export default {
    "common": {
      "edit": "editar",
      "welcome_message": "Bem-vindo ao ELSA para organizações",
      "slogan": "Fale inglês com fluência, facilidade e confiança",
      "invited_by": "Convidado por",
      "agree_to": "Concordo com os",
      "terms_and_conditions": "Termos e Condições ELSA",
      "search": "Pesquisar",
      "email": "E-mail",
      "cancel": "Cancelar",
      "save": "Salvar",
      "or": "ou",
      "account_confirmed": "Sua conta foi confirmada.",
      "no_values": "Sem valores",
      "terms_and_privacy_policy": "Termos e Política de Privacidade",
      "continue": "Continuar",
      "invite": "Convidar",
      "generic_error_message": "Algo de errado aconteceu. Tente novamente mais tarde.",
      "error_duplidate_group_name": "Nome de sala duplicado no arquivo",
      "login": "Login",
      "and": "e",
      "terms_of_use": "Termos de Uso",
      "privacy_policy": "Política de Privacidade",
      "name": "Nome",
      "view_list": "Ver lista",
      "total": "Total",
      "lessons": "Lições",
      "hours": "Horas",
      "average": "Média",
      "lessons_per_day": "Lições por dia",
      "minutes_per_day": "Minutos por dia",
      "pending_invites": "Convites pendentes",
      "invite_success": "O convite foi aceito com sucesso",
      "invite_not_success": "O convite não pôde ser aceito",
      "invite_send_not_success": "O convite não pode ser reenviado",
      "no_invite_seleted": "Nenhum convite selecionado",
      "select_all": "Selecionar tudo",
      "minutes": "Minutos",
      "warnings": {
        "no_report_data": "Não foi possível apresentar relatórios, tente novamente",
        "session_expired": "Sua sessão expirou. Faça login novamente"
      },
      "resend_invite": "Reenviar convite",
      "remove_invite": "Remover convite pendente",
      "export_report": "Exportar relatório",
      "export_assessment": "Exportar avaliação",
      "lesson_detail": "Detalhes da lição",
      "file_type_not_allowed": "Tipo de arquivo não suportado",
      "import": "Importar",
      "assessment-history": "Histórico de avaliações"
    },
    "date_interval_picker": {
      "start_end_date": "Data de início e término",
      "save": "Salvar",
      "cancel": "Cancelar",
      "this_month": "Este mês",
      "apply": "Aplicar"
    },
    "date_picker": {
      "start_date": "Data de início",
      "end_date": "Data de término",
      "to": "Até",
      "last_week": "Semana passada",
      "last_month": "Mês passado",
      "last_three_months": "Últimos três meses",
      "last_six_months": "Últimos seis meses",
      "last_year": "Ano passado",
      "daily": "Daily",
      "weekly": "Semanal",
      "monthly": "Mensal"
    },
    "company_labels": {
      "average_lessons": "Número de dias de prática por semana",
      "all_users": "Todos os colaboradores",
      "groups": "Equipes",
      "teachers": "Líderes de equipe",
      "remove_teacher_from_organization": "Remover líder da organização",
      "remove_student_from_organization": "Remover colaborador da organização",
      "remove_student_from_group": "Remover Aluno da Equipe",
      "active_students": "Colaboradores ativos",
      "teacher": "Líder de equipe",
      "students": "Colaboradores",
      "student": "Colaborador",
      "all_groups": "Todas as equipes",
      "edit_group": "Editar equipe",
      "add_to_group_title": "Adicionar à equipe",
      "add_to_group": "Nova equipe",
      "import_class_success_title": "{numberClassesImported} equipe(s) foi/foram criada(s) com sucesso",
      "add_to_group_success": "Usuários foram adicionados à equipe",
      "add_to_group_warning": "Não foi possível adicionar usuários à equipe",
      "remove_from_class_success": "Usuários foram removidos da equipe",
      "remove_from_class_warning": "Os usuários não puderam ser removidos da equipe",
      "assign_license_to_user_success": "Atribuir licença ao usuário com sucesso",
      "assign_license_to_user_warning": "Atribuir licença ao usuário sem sucesso",
      "create_new_group": "Criar nova equipe",
      "no_groups_yet": "Você ainda não tem uma equipe.",
      "no_students_yet": "Você ainda não tem colaboradores.",
      "create_group": "Criar equipe",
      "import_groups": "Importar equipes",
      "import_groups_success": "As equipes foram criadas",
      "import_users_to_groups_success": "A importação de colaboradores para equipes foi bem-sucedida",
      "group_title": "Título da equipe",
      "group_name": "Nome da equipe",
      "group_details": "Detalhes da equipe",
      "step_group_details": "{step}. Detalhes da equipe",
      "no_teachers_available": "Nenhum líder disponível",
      "all_teachers": "Todos os líderes",
      "all_students": "Todos os colaboradores",
      "upload_emails": "Importar colaboradores para a equipe",
      "errors": {
        "please_provide_group_name": "Informe o nome da equipe",
        "please_provide_teacher_name": "Informe o nome de um líder"
      },
      "add_students": "Adicionar colaboradores",
      "group_overview": "Visão geral da equipe",
      "group_teacher": "Líder de equipe",
      "will_be_added_students": "{numberOfUsers} colaboradores serão adicionados à sala assim que você criá-la.",
      "student_consent_to_class":"{numberOfUsers} colaborador(es) será(ão) inscrito(s) automaticamente na equipe.",
      "students_list": "Lista de colaboradores",
      "your_group_was_created": "Sua equipe foi criada,",
      "error_when_inviting": "mas houve um erro ao convitar colaboradores. Tente novamente mais tarde.",
      "invited_users": "e {students} colaboradores foram convidados!",
      "goals": {
        "engage_students": "Engaje seus colaboradores",
        "engage_review": "Você pode solicitar que seus fornecedores comecem a praticar inglês. Sugerimos começar com:",
        "get_insight_about_students": "Receba informações sobre as habilidades de pronúncia atuais dos colaboradores"
      },
      "invite_students": "Convidar colaboradores",
      "student_name": "Nome do colaborador",
      "teachers_page": {
        "title": "Líderes de equipe",
        "invite": "Convidar líderes",
        "table": {
          "number_of_students": "Nº de colaboradores",
          "number_of_classes": "Nº de equipes"
        }
      },
      "students_page": {
        "title": "Colaboradores",
        "invite": "Convidar colaboradores"
      },
      "select_teacher": "Selecionar um líder",
      "add_new_teacher": "Adicionar novo líder",
      "dashboard": {
        "class_overview": "Visão geral da equipe",
        "view_class": "Ver equipe",
        "profile": "Perfil da empresa",
        "add_student": "Convidar colaboradores",
        "new_group": "Criar nova equipe",
        "add_teacher": "Convidar líderes"
      },
      "teacher_info": {
        "show_list_of_classes": "Exibir lista de equipes",
        "show_list_of_students": "Exibir lista de colaboradores",
        "classes_assigned_to": "Equipes atribuidas a",
        "show_all_classes": "Exibir todas as equipes"
      },
      "classes": {
        "active_students": "Colaboradores ativos (prática em pelo menos uma lição) ",
        "import_users": "Importar colaboradores para equipes múltiplas"
      },
      "students_improvement": "Melhoria da equipe",
      "auto_enroll_message_confirm": "Colaboradores serão inscritos automaticamente na equipe. <br/>Ao selecionar a opção de inscrição automática, você deverá ter a permissão dos estudantes para adicioná-los a esta sala/equipe. <br/>Deseja continuar?",
      "accept_invitation_enroll_message_confirm": "Os colaboradores precisam aceitar o convite individualmente para se inscrever na equipe. Deseja continuar?",
      "pending_invites_teacher": "Convites pendentes de líderes"
    },
    "school_labels": {
      "average_lessons": "Número de dias com prática por semana",
      "all_users": "Todos os estudantes",
      "groups": "Salas",
      "teachers": "Professores",
      "teacher": "Professor",
      "students": "Estudantes",
      "student": "Estudante",
      "active_students": "Estudantes ativos",
      "remove_teacher_from_organization": "Remover líder da organização",
      "remove_student_from_organization": "Remover estudante da organização",
      "remove_student_from_group": "Remover Aluno da Classe",
      "all_teachers": "Todos os professores",
      "all_students": "Todos os alunos",
      "all_groups": "Todas as salas",
      "edit_group": "Editar sala",
      "add_to_group_title": "Adicionar à sala",
      "add_to_group": "Nova sala",
      "import_class_success_title": "{numberClassesImported} salas foram criadas com sucesso ",
      "add_to_group_success": "Usuários foram adicionados à sala",
      "add_to_group_warning": "Não foi possível adicionar usuários à sala",
      "remove_from_class_success": "Usuários foram removidos da equipe",
      "remove_from_class_warning": "Os usuários não puderam ser removidos da equipe",
      "assign_license_to_user_success": "Atribuir licença ao usuário com sucesso",
      "assign_license_to_user_warning": "Atribuir licença ao usuário sem sucesso",
      "create_new_group": "Criar nova sala",
      "no_groups_yet": "Você ainda não tem uma sala.",
      "no_students_yet": "Você ainda não tem estudantes.",
      "no_teachers_available": "Nenhum professor disponível",
      "create_group": "Criar sala",
      "import_groups": "Importar salas ",
      "import_groups_success": "As salas foram criadas",
      "import_users_to_groups_success": "Importação de estudantes para as salas bem-sucedida",
      "group_title": "Título da sala",
      "group_name": "Nome da sala",
      "group_details": "Detalhes da sala",
      "step_group_details": "{step}. Detalhes da sala",
      "select_teacher": "Selecione um professor",
      "add_new_teacher": "Adicionar novo professor",
      "upload_emails": "Importar estudantes para a sala",
      "errors": {
        "please_provide_group_name": "Informe o nome da sala",
        "please_provide_teacher_name": "Informe o nome do professor"
      },
      "add_students": "Adicionar estudantes",
      "group_overview": "Visão geral da sala",
      "group_teacher": "Professor da sala",
      "will_be_added_students": "{numberOfUsers} estudantes serão adicionados à sala assim que você criá-la.",
      "student_consent_to_class":"{numberOfUsers} estudante(s) será(ão) inscrito(s) automaticamente na sala.",
      "students_list": "Lista de estudantes",
      "your_group_was_created": "Sua sala foi criada,",
      "error_when_inviting": "mas houve um erro ao convidar estudantes. Tente novamente mais tarde.",
      "invited_users": "e {students} estudantes foram convidados!",
      "goals": {
        "engage_students": "Engaje seus estudantes",
        "engage_review": "Você pode solicitar que seus estudantes comecem a praticar inglês. Sugerimos começar com:",
        "get_insight_about_students": "Receba informações sobre as habilidades de pronúncia atuais de seus estudantes"
      },
      "invite_students": "Convidar estudantes",
      "student_name": "Nome do estudante",
      "teachers_page": {
        "title": "Professores",
        "invite": "Convidar professores",
        "table": {
          "number_of_students": "Nº de estudantes",
          "number_of_classes": "Nº de salas"
        }
      },
      "students_page": {
        "title": "Estudantes",
        "invite": "Convidar estudantes"
      },
      "dashboard": {
        "class_overview": "Visão geral da sala",
        "view_class": "Ver sala",
        "profile": "Perfil da escola",
        "add_student": "Convidar estudantes",
        "new_group": "Criar nova sala",
        "add_teacher": "Convidar professores"
      },
      "teacher_info": {
        "show_list_of_classes": "Exibir lista de salas",
        "show_list_of_students": "Exibir lista de estudantes",
        "classes_assigned_to": "Salas atribuídas a",
        "show_all_classes": "Exibir todas as salas"
      },
      "classes": {
        "active_students": "Estudantes ativos (prática de pelo menos uma lição)",
        "import_users": "Importar alunos para salas múltiplas"
      },
      "students_improvement": "Melhoria da sala",
      "auto_enroll_message_confirm": "Estudante(s) será(ão) inscrito(s) automaticamente na sala. <br/>Ao selecionar a opção de inscrição automática, você deverá ter permissão dos alunos para adicioná-los a esta sala. <br/><br/>Deseja continuar?",
      "accept_invitation_enroll_message_confirm": "Estudante(s) precisa(m) aceitar o convite individualmente para participar da sala. <br/>Deseja continuar?",
      "pending_invites_teacher": "Convites pendentes de professores",
      "delete_user_from_class_message_confirm":"Tem certeza de que deseja excluir o aluno?",
    },
    "elsa_goals": {
      "goals": "Use o melhor aplicativo de pronúncia para ajudar seus alunos a aprimorar suas habilidades em inglês:",
      "goal1": "Agendar salas flexíveis",
      "goal2": "Observar relatórios de progresso",
      "goal3": "Convidar estudantes individualmente ou em grupo"
    },
    "navbar": {
      "dashboard": "Painel de controle",
      "classes": "Salas",
      "teachers": "Professores",
      "students": "Estudantes",
      "account": "Conta",
      "my_profile": "Meu perfil",
      "manage": "Lista de organizações",
      "logout": "Sair",
      "hello": "Olá",
      "organizations": "Organizações",
      "org_current": "Organização atual",
      "Language": "Idioma"
    },
    "teacher_info": {
      "profile": "Perfil",
      "first_name": "Primeiro nome",
      "last_name": "Sobrenome",
      "email": "E-mail",
      "username": "Nome de usuário",
      "phone_number": "Telefone",
      "user_roles": "Funções do usuário",
      "department": "Departamento",
      "title": "Título",
      "user_role": "Função do usuário",
      "overview": "Visão geral"
    },
    "student_info": {
      "overview": "Visão geral",
      "profile": "Perfil"
    },
    "user_profile": {
      "title": "",
      "dont_belong_organization": "Você não faz parte de nenhuma organização.",
      "join_organization": "Juntar-se à organização",
      "create_organization": "Criar organização",
      "withdraw_from_organization": "Sair da organização",
      "your_profile": {
        "title": "seu perfil",
        "first_name": "Primeiro nome",
        "last_name": "Sobrenome",
        "user_name": "Nome de usuário",
        "email": "E-mail",
        "not_verified": "Não verificado",
        "phone_number": "Telefone",
        "did_not_receive": "Não recebeu o e-mail de confirmação?",
        "resent_email": "Reenviar e-mail",
        "modals": {
          "edit_profile": {
            "update_success": "Usuário importado com sucesso.",
            "title": "Editar perfil",
            "upload_image": {
              "label": "Carregar imagem"
            },
            "first_name": {
              "label": "Primeiro nome",
              "placeholder": "Insira seu primeiro nome"
            },
            "last_name": {
              "label": "Sobrenome",
              "placeholder": "Insira seu sobrenome"
            },
            "email": {
              "label": "E-mail",
              "placeholder": "Insira seu endereço de e-mail"
            },
            "user_name": {
              "label": "Nome de usuário",
              "placeholder": "Insira seu nome de usuário"
            },
            "phone": {
              "label": "Telefone",
              "placeholder": "+55-00000-0000"
            },
            "save": "salvar",
            "cancel": "cancelar"
          },
          "confirm_new_email": {
            "title": "Confirme seu novo endereço de e-mail",
            "message": "Enviamos um e-mail de confirmação. Acesse sua caixa de entrada e faça a verificação do seu novo endereço de e-mail.",
            "button_label": "Entendi!"
          }
        }
      },
      "change_password": {
        "title": "alterar senha",
        "password": "senha",
        "modals": {
          "title": "alterar senha",
          "current_password": {
            "label": "Senha atual",
            "placeholder": "Insira a senha atual"
          },
          "new_password": {
            "label": "Nova senha",
            "placeholder": "Insira a nova senha"
          },
          "confirm_new_password": {
            "label": "Repetir nova senha",
            "placeholder": "Repita a nova senha"
          },
          "save": "salvar",
          "cancel": "cancelar",
          "change_pass_elsa": "Use o aplicativo ELSA para alterar sua senha."
        }
      },
      "your_organizations": {
        "title": "suas organizações",
        "modals": {
          "title": "sair de {name}",
          "admin": {
            "message_1": "Tem certeza que deseja sair de {name}?",
            "message_2": "Você é o único administrador de {name}. Para sair da organização, convide alguém para ser o responsável pela conta."
          },
          "teacher": {
            "message_1": "Tem certeza que deseja sair de {name}? Você perderá o acesso à sua licença pro atual.",
            "message_2": "Você é o professor atribuído a {numberOfClasses} salas. Para sair da organização, entre em contato com o administrador para removê-lo desta função."
          },
          "student": {
            "message_1": "Se você sair, precisará de um novo convite para se juntar à sala {name} novamente.",
            "message_2": "Tem certeza que deseja sair de {name}? Você perderá o acesso à sua licença pro atual."
          },
          "confirm": "sim, sair",
          "cancel": "não, cancelar",
          "got_it": "entendi!"
        }
      },
      "social": {
        "title": "social",
        "modals": {
          "title": "Inserir senha",
          "subtitle": "Insira uma senha para acessar sua conta ELSA sem o Facebook",
          "password": {
            "label": "Nova senha",
            "placeholder": "Insira a nova senha"
          },
          "repeat_password": {
            "label": "Repetir nova senha",
            "placeholder": "Repita a nova senha"
          },
          "save": "salvar",
          "cancel": "cancelar"
        }
      },
      "delete_account": {
        "button": "excluir conta",
        "modals": {
          "title": "excluir conta",
          "warning": "Tem certeza que deseja sair de {organizationName}? Caso sim, preencha as seguintes informações:",
          "terms_and_conditions": "Estou ciente de que perderei acesso aos dados do meu histórico e à minha licença atual.",
          "password": "Senha",
          "delete_account": "excluir conta",
          "cancel": "cancelar"
        }
      }
    },
    "login": {
      "title": "Entre em sua conta ELSA",
      "accept_invitation": "Faça login em sua conta ELSA para aceitar o convite de {organizationName}.",
      "email_field": {
        "label": "e-mail",
        "placeholder": "Insira o endereço de e-mail"
      },
      "password_field": {
        "label": "senha",
        "placeholder": "Insira sua senha"
      },
      "forgot_password": "Esqueceu a senha?",
      "login_and_accept_invitation": "Faça login e aceite o convite",
      "dont_have_account": "Não tem uma conta?",
      "create_account": "Criar a conta",
      "login": "Entrar",
      "invalid_token": "O convite expirou ou é inválido"
    },
    "confirm_account": {
      "title": "Confirmar sua conta",
      "check_inbox": "Enviamos um e-mail de confirmação. Acesse sua caixa de entrada e faça a verificação de sua conta.",
      "didnt_receive": "Não recebeu?",
      "resend_confirmation": "Reenviar e-mail de confirmação",
      "got_it": "Entendi!"
    },
    "resend_confirmation": {
      "title": "Reenviar e-mail de confirmação",
      "send_confirmation": "Enviaremos um novo e-mail de confirmação. Certifique-se de que o endereço de e-mail está correto.",
      "email_field": {
        "label": "e-mail",
        "placeholder": "Insira o endereço de e-mail"
      },
      "resend_email": "Reenviar e-mail"
    },
    "recover_password": {
      "title": "Recuperar senha",
      "enter_email_to_reset": "Insira seu endereço de e-mail para redefinir sua senha",
      "reset_pass_elsa": "Use o aplicativo ELSA para redefinir sua senha.",
      "email_field": {
        "label": "endereço de e-mail",
        "placeholder": "Insira o endereço de e-mail"
      },
      "reset_password": "Redefinir senha",
      "sent_email_check_inbox": "Enviamos um e-mail. Acesse sua caixa de entrada e redefina sua senha.",
      "got_it": "Entendi!"
    },
    "reset_password_modal": {
      "title": "Redefinir senha",
      "enter_your_password": "Insira sua nova senha",
      "button_text": "Redefinir senha",
      "new_password_field": {
        "label": "Nova senha",
        "placeholder": "Insira a nova senha"
      },
      "confirm_password_field": {
        "label": "Confirmar nova senha",
        "placeholder": "Insira a nova senha mais uma vez"
      }
    },
    "sign_up": {
      "title": "Criar conta ElSA",
      "sign_up": "Registrar",
      "first_name_field": {
        "label": "Primeiro nome",
        "placeholder": "Insira o primeiro nome"
      },
      "last_name_field": {
        "label": "Sobrenome",
        "placeholder": "Insira o sobrenome"
      },
      "email_field": {
        "label": "Endereço de e-mail",
        "placeholder": "Insira o endereço de e-mail"
      },
      "password_field": {
        "label": "Senha",
        "placeholder": "Insira a senha"
      },
      "signup_accept_invitation": "Registrar e aceitar convite",
      "invitation_code": "Você tem um código de convite?",
      "tooltip_message": "Caso tenha um código de convite, insira-o aqui.",
      "by_signing_up_to_elsa": "Ao se registrar no ELSA, você concorda com nossos",
      "already_have_an_account": "Já tem uma conta?"
    },
    "verify_facebook_info_modal": {
      "title": "verifique sua conta",
      "save_continue": "Salvar e continuar",
      "first_name_field": {
        "label": "Primeiro nome",
        "placeholder": "Primeiro nome"
      },
      "last_name_field": {
        "label": "Sobrenome",
        "placeholder": "Sobrenome"
      },
      "email_field": {
        "label": "Endereço de e-mail ",
        "placeholder": "Insira o endereço de e-mail"
      }
    },
    "organizations": {
      "groups": "Grupos",
      "users": "Usuários",
      "table": {
        "user_email": "Endereço de e-mail",
        "username": "Nome",
        "titleDept": "título/dept.",
        "roles": "Função",
        "actions": "ações",
        "empty": "Nenhum usuário encontrado",
        "empty_admin": "Nenhum administrador encontrado",
        "empty_student": "Nenhum estudante encontrado",
        "empty_teacher": "Nenhum professor encontrado"
      },
      "users_section": {
        "invite_users": "Convidar usuários",
        "invite_by_email": "Convidar por e-mail",
        "import_users": "Importar usuários para grupos múltiplos",
        "import_elsa_id": "Importar Elsa_Id para grupos múltiplos",
        "share_code": "Obter código",
        "share_link": "Compartilhar link",
        "share_qr_code": "Compartilhar QR code",
        "add_to_group": "Adicionar a grupo",
        "add_to_class": "Adicionar à sala",
        "revoke_license": "Anular licença",
        "enable_license": "Habilitar licença",
        "disable": "Desabilitar",
        "delete": "Excluir",
        "no_users": "Convide usuários para se juntar à sua empresa:",
        "no_users_1": "Você ainda não tem usuários.",
        "no_users_2": "Adicione usuários ou compartilhe sua organização com eles.",
        "select_role": "Selecionar função",
        "user_profile": {
          "user_details": {
            "title": "Detalhes do usuário"
          },
          "user_roles": {
            "title": "Função do usuário"
          }
        },
        "enable_license_message": "Licença Pro emitida para {firstName} {lastName}",
        "modals": {
          "share_qr_code": {
            "title": "Compartilhar QR code",
            "print_code": "Imprima a seguinte QR code",
            "share_with_users": "Compartilhe-o com os usuários para que o escaneiem e se juntem à sua organização.",
            "print": "Imprimir",
            "no_cancel": "Cancelar"
          },
          "share_link": {
            "title": "Compartilhar link",
            "copy_link": "Copiar link",
            "got_it": "Entendi!",
            "cancel": "Cancelar"
          },
          "share_code": {
            "title": "Obter código",
            "share_the_following_code": "Gerar código",
            "user_can_join": "Compartilhe o código com os usuários para que o usem e se juntem à sua organização.",
            "generate_code": "Gerar código",
            "done": "Pronto"
          },
          "invite_users": {
            "copy_and_paste": "Copie e cole os endereços de e-mail ",
            "title": "Enviar convite por e-mail",
            "select_role_placeholder": "Selecione a função do usuário",
            "select_role_label": "Função do(s) usuário(s)",
            "copy_paste_emails": "Copie e cole os endereços de e-mail",
            "invite_users": "Convidar usuários",
            "add_email": "Insira múltiplos endereços de e-mail (separados por vírgula)",
            "success": "Os usuários foram adicionados à lista de usuários",
            "consent": "Concordar",
            "consent1": "Inscrever automaticamente o(s) usuário(s) em {organizationName}"
          },
          "edit_user": {
            "update_success": "Atualizado com sucesso",
            "title": "Editar função do usuário",
            "user_title": "Selecionar título",
            "user_title_placeholder": "Título",
            "department": "Selecionar departamento",
            "department_placeholder": "Departamento"
          },
          "disable": {
            "title": "Desabilitar {numberOfAccounts} contas de usuários",
            "message": "Você tem certeza que deseja anular as licenças pro de {numberOfAccounts} usuários?",
            "confirm": "Sim, anular",
            "cancel": "Não, cancelar"
          },
          "delete": {
            "title": "Remover usuários desta organização",
            "message": "Você tem certeza que deseja remover {numberOfAccounts} usuários de sua organização?",
            "confirm": "Sim, remover",
            "cancel": "Não, cancelar"
          },
          "delete_from_class": {
            "title": "Remover usuários da equipe",
            "message": "Tem certeza que deseja remover {numberOfAccounts} usuário (s) de sua equipe?",
            "confirm": "Sim, remover",
            "cancel": "Não, cancelar"
          }
        },
        "popovers": {
          "groups": {
            "title": "Adicionar ao grupo",
            "add_group": "Adicionar grupo",
            "manage_groups": "Gerenciar grupos"
          },
          "classes": {
            "title": "Adicionar à sala",
            "new_class": "Nova sala"
          },
          "roles": {
            "title": "Editar funções"
          }
        }
      },
      "invite_users": {
        "title": "Convidar usuários",
        "subtitle": "Convide usuários para se juntarem à sua empresa:",
        "import_users": "Importar lista de endereços de e-mail para o grupo selecionado",
        "import_users_classes": "Importar lista de endereços de e-mail para diversos grupos",
        "share_link": "Compartilhar link",
        "mail_invite": "Copie e cole endereços de e-mail",
        "multiple_mail_invite_with_enrolled": "{numberOfInvites} usuário(s) foi/foram inscrito(s) neste grupo",
        "multiple_mail_invite": "{numberOfInvites} usuário(s) foi/foram convidado(s)",
        "multiple_mail_to_invite": "{numberOfInvites} usuário(s) foi/foram convidado(s)",
        "import": {
          "elsa-title": "importar lista de IDs de usuários ELSA",
          "title": "importar lista de endereços de e-mail",
          "subtitle": "Importar lista",
          "instructions": "Arraste e solte seus arquivos aqui para carregá-los.",
          "files": "{fileCount} arquivo(s) foi/foram carregado(s)",
          "instructions2": "Faça o download do template em",
          "instructions3": "preencha-o e arraste-o para importar",
          "get_template": "Obter template",
          "get_template_xlsx": "Formato MS Excel",
          "get_template_csv": "Formato CSV",
          "browse_files": "Pesquisar arquivos"
        },
        "link": {
  
        },
        "mail": {
          "title": "Copie e cole endereços de e-mail"
        },
        "confirmation_title": "Confirmação",
        "warning_message_delay_invite": "Por favor, ten en cuenta: El proceso de invitación puede tardar unos minutos en completarse. Vuelve más tarde para ver la lista de usuarios actualizada."
      }
    },
    "table_row": {
      "actions": {
        "remove_from_group": "Remover do grupo",
        "add_to_class": "Adicionar à sala",
        "disable": "Disabilitar",
        "delete": "Excluir"
      }
    },
    "organization_profile": {
      "title": "Perfil",
      "admins": "Administrador(es)",
      "invite_another_admin": "Convidar outro administrador",
      "pending_request": "Solicitação pendente",
      "organization_name": "Nome da organização",
      "organization_username": "Nome de usuário da organização",
      "organization_type_industry": "Tipo de organização/indústria",
      "phone": "Telefone",
      "address": "Endereço",
      "affiliate": "Afiliado",
      "admin_actions": {
        "remove_from_admin": "Remover",
        "edit_user": "Editar usuário",
        "remove_from_organization": "Remover da organização",
        "user_id_only_admin": "Não é possível remover o único administrador de uma organização."
      },
      "remove_admin_modal": {
        "title": "Remover administrador",
        "yes_remove": "Sim, remover",
        "no_cancel": "Não, cancelar"
      },
      "invite_admin_modal": {
        "invite_success": "O convite foi enviado.",
        "remove_invite_success": "A remoção do convite foi bem-sucedida",
        "remove_invite_fail": "Não foi possível remover o convite",
        "confirm_remove_invitation": "Você deseja remover este convite?",
        "title": "Convidar novo administrador",
        "email_field": {
          "label": "Endereço de e-mail",
          "placeholder": "Insira o endereço de e-mail"
        },
        "invite_button": "Convidar",
        "cancel_button": "Cancelar"
      },
      "delete_disable_organization_modal": {
        "title_delete": "Excluir",
        "title_disable": "Desabilitar",
        "title_enable": "Habilitar",
        "password_field": {
          "label": "Senha",
          "placeholder": "Insira a senha"
        },
        "delete_button": "Excluir organização",
        "disable_button": "Sim, desabilitar",
        "enable_button": "Sim, habilitar",
        "cancel_button": "Cancelar",
        "delete_terms": "Estou ciente de que perderei o acesso aos dados de meu histórico e minhas licenças atuais.",
        "disable_terms": "Estou ciente de que os usuários perderão suas licenças pagas.",
        "are_you_sure_disable": "Tem certeza que deseja desabilitar ",
        "are_you_sure_enable": "Tem certeza que deseja habilitar",
        "are_you_sure_widthraw": "Tem certeza que deseja sair de ",
        "if_so_fill_following": "Caso tenha, insira as seguintes informações:"
      },
      "edit_organization_modal": {
        "invite_not_send": "A organização foi criada, mas os convites não foram enviados.",
        "update_success": "A organização foi atualizada",
        "create_success": "O organização foi criada",
        "create_title": "Criar nova organização",
        "edit_title": "Editar organização",
        "save": "Salvar",
        "cancel": "Cancelar",
        "upload_logo_field": {
          "label": "Carregar logo"
        },
        "verified_organization": "Verificar organização",
        "enable_organization": "Habilitar organização",
        "disable_organization": "Desabilitar organização",
        "delete_organization": "Excluir organização",
        "are_you_sure_disable": "Tem certeza que deseja desabilitar",
        "name_field": {
          "label": "Nome da organização",
          "placeholder": "Insira o nome da organização"
        },
        "username_field": {
          "label": "Nome de usuário",
          "placeholder": "Insira o nome de usuário da organização"
        },
        "org_type_field": {
          "label": "Tipo de organização",
          "placeholder": "Selecione o tipo de organização"
        },
        "industry_field": {
          "label": "Indústria",
          "placeholder": "Selecione a indústria"
        },
        "address_field": {
          "label": "Endereço",
          "placeholder": "Insira o endereço da organizaçãoEnter organization address"
        },
        "phone_field": {
          "label": "Telefone",
          "placeholder": "+55-00000-0000"
        },
        "country_field": {
          "label": "País",
          "placeholder": "Insira o país"
        },
        "state_field": {
          "label": "Estado",
          "placeholder": "Insira o estado"
        },
        "city_field": {
          "label": "Cidade",
          "placeholder": "Insira a cidade"
        },
        "post_code_field": {
          "label": "Código postal",
          "placeholder": "Código postal"
        },
        "owner_field": {
          "label": "Proprietário da conta",
          "placeholder": "Proprietário"
        },
        "affiliate_field": {
          "label": "Afiliado",
          "placeholder": "Nenhum"
        },
        "timezone_field": {
          "label": "Fuso horário",
          "placeholder": "UTC/GMT"
        }
      }
    },
    "admin": {
      "organizations": {
        "title": "Organizações",
        "create_new_organization": "Criar nova organização",
        "import_organizations": "Importar organizações",
        "verify": "Verificar",
        "table": {
          "verification": "Verificação",
          "not_verified": "Não verificada",
          "verified": "Verificada",
          "organization_name": "Nome da organização",
          "status": "Status",
          "licences": "Licenças",
          "empty": "Nenhuma organização encontrada",
          "active": "Ativo",
          "inactive": "Inativo",
          "affiliate": "Afiliado",
          "created_at": "Data de criação"
        },
        "filter_menu": {
          "all": "Todos",
          "active": "Ativo",
          "disabled": "Desabilitado",
          "verified": "Verificado"
        }
      }
    },
    "organization_page": {
      "organizations": "Organizações",
      "disable": "Desabilitar",
      "delete": "Excluir",
      "menu": {
        "licences": "Licenças",
        "users": {
          "title": "Usuários",
          "all_users": "Todos os usuários",
          "employees": "Colaboradores",
          "leads": "Líderes de equipe",
          "admins": "Administradores"
        },
        "groups": "Grupos",
        "profile": "Perfil"
      }
    },
    "disable_organization_modal": {
      "title": "Desabilitar",
      "yes_disable": "Sim, desabilitar",
      "no_cancel": "Não, cancelar"
    },
    "onboarding": {
      "welcome": "Bem-vindo ao ELSA",
      "welcome_subtitle": "Conte-nos um pouco mais sobre você, para que possamos orientá-lo em sua jornada com ELSA.",
      "who_are_you": "Quem é você?",
      "select_option": "Selecione uma das opções abaixo",
      "school": "Escola",
      "school_admin": "Administrador de escola",
      "company": "Empresa",
      "company_admin": "Administrador de empresa",
      "teacher": "Professor",
      "student": "Estudante",
      "continue": "Continuar"
    },
    "school": {
      "setup_school": {
        "successfully_created": "Sua escola foi criada com sucesso.",
        "setup_your_school": "Configure sua escola",
        "invite_students_teachers": "Convide seus estudantes e professores para se juntarem à sua organização.",
        "create_your_first_class": "Crie sua primeira sala!",
        "create_class": "Criar sala",
        "invite_teachers": "Convidar professores",
        "invite_students": "Convidar estudantes",
        "teacher": "Professor",
        "continue": "Continuar"
      },
      "create_edit_modal": {
        "title": "Criar escola",
        "create": "Criar",
        "cancel": "Cancelar",
        "name_field": {
          "label": "Nome da escola",
          "placeholder": "Insira o nome da escola"
        },
        "username_fields": {
          "label": "Nome de usuário",
          "placeholder": "Insira o nome de usuário"
        },
        "type_field": {
          "label": "Tipo de escola",
          "placeholder": "Selecione o tipo de escola"
        },
        "industry_field": {
          "label": "Indústria",
          "placeholder": "Selecione a indústria"
        },
        "address_field": {
          "label": "Endereço",
          "placeholder": "Selecione o endereço da escola"
        },
        "phone_field": {
          "label": "Telefone",
          "placeholder": "+55-00000-0000",
          "code": "Código"
        },
        "country_field": {
          "label": "País",
          "placeholder": "Insira o país"
        },
        "state_field": {
          "label": "Estado",
          "placeholder": "Insira o estado"
        },
        "city_field": {
          "label": "Cidade",
          "placeholder": "Insira a cidade"
        },
        "post_code_field": {
          "label": "Código postal",
          "placeholder": "00000-000"
        }
      }
    },
    "company": {
      "setup_company": {
        "successfully_created": "Sua empresa foi criada com sucesso.",
        "setup_your_company": "Configure sua empresa",
        "invite_students_teachers": "Convide estudantes e professores para se juntarem à sua empresa.",
        "create_class": "Criar sala",
        "invite_teachers": "Convidar professores",
        "invite_students": "Convidar estudantes",
        "continue": "Continuar"
      },
      "create_edit_modal": {
        "title": "Criar empresa",
        "create": "Criar",
        "cancel": "Cancelar",
        "name_field": {
          "label": "Nome da empresa",
          "placeholder": "Insira o nome da empresa"
        },
        "username_field": {
          "label": "Nome de usuário da empresa",
          "placeholder": "Insira o nome de usuário da empresa"
        },
        "type_field": {
          "label": "Tipo de empresa",
          "placeholder": "Insira o tipo de empresa"
        },
        "industry_field": {
          "label": "Tipo de indústria",
          "placeholder": "Insira a indústria"
        },
        "address_field": {
          "label": "Endereço",
          "placeholder": "Insira o endereço da escola"
        },
        "phone_field": {
          "label": "Telefone",
          "placeholder": "+55-00000-0000",
          "code": "Código"
        },
        "country_field": {
          "label": "País",
          "placeholder": "Insira o país"
        },
        "state_field": {
          "label": "Estado",
          "placeholder": "Insira o estado"
        },
        "city_field": {
          "label": "Cidade",
          "placeholder": "Insira a cidade"
        },
        "post_code_field": {
          "label": "Código postal",
          "placeholder": "00000-000"
        }
      }
    },
    "teacher": {
      "are_you_part_of_organization": "Você faz parte de uma organização?",
      "select_one_options": "Selecione uma das opções abaixo",
      "yes": "Sim",
      "no": "Não",
      "teach_myself": "Sou autodidata",
      "continue": "Continuar",
      "do_you_have_invitation_code": "Você tem um código de convite?"
    },
    "student": {
      "are_you_part_of_organization": "Você faz parte de uma organização?",
      "select_one_options": " Selecione uma das opções abaixo",
      "yes": "Sim",
      "no": "Não",
      "learning_myself": "Estou estudando por conta própria",
      "continue": "Continuar",
      "do_you_have_invitation_code": " Você tem um código de convite?"
    },
    "setup_organization": {
      "join_your_organization": "Junte-se à sua organização",
      "wait_for_admin": "Aguarde o administrador enviar um convite ou insira um código de convite.",
      "enter_invitation_code": "Inserir código de convite",
      "continue": "Continuar",
      "welcome_to_organization": "Bem-vindo à organização A",
      "you_can_create_own_class": "Você pode criar sua própria sala ou esperar o administrador encaminhá-lo a uma sala",
      "create_class": "Criar sala"
    },
    "start_learning": {
      "start_learning": "Comece a aprender",
      "download_elsa_app": "Faça o download do aplicativo ELSA Speak em seu dispositivo móvel:",
      "or_send_the_email_by_link_sms": "Ou receba o link para download por e-mail ou mensagem de texto/SMS:",
      "send_email_link": "Envie-me o link por e-mail",
      "send_sms_link": "Envie-me o link por SMS",
      "start_practice": "Comece a praticar",
      "you_can_download": "Você pode fazer o download do aplicativo e começar a praticar:",
      "to_join_our_organization": "Para se juntar à sua organização, aguarde o administrador enviar um convite ou insira um código de convite",
      "enter_invitation_code": "Inserir código de convite",
      "email_link_sent": "Link enviado por e-mail",
      "sms_link_sent": "Link enviado por SMS",
      "get_email_link_modal": {
        "title": "Receber link por e-mail",
        "get_email_link": "Rebeba o link por e-mail",
        "email_field": {
          "label": "E-mail",
          "placeholder": "Insira o endereço de e-mail"
        },
        "phone_type_field": {
          "label": "Tipo de telefone",
          "placeholder": "Tipo de telefone"
        },
        "success": "E-mail enviado.",
        "warning": "Não foi possível enviar o e-mail. Tente novamente mais tarde. "
      },
      "send_sms_link_modal": {
        "title": "Receber link por SMS",
        "get_sms_link": "Rebeba o link por SMS",
        "phone_type_field": {
          "label": "Tipo de telefone",
          "placeholder": "Tipo de telefone"
        },
        "phone_field": {
          "label": "Telefone",
          "placeholder": "+55-00000-0000",
          "code": "Código"
        },
        "success": "SMS enviado.",
        "warning": " Não foi possível enviar o SMS. Tente novamente mais tarde."
      }
    },
    "industries": {
      "aerospace": "Aeroespacial",
      "transportation": "Transporte",
      "computer_software_internet": "Comutador, software e internet",
      "telecommunication": "Telecomunicações",
      "food_and_agriculture": "Alimentos e agricultura",
      "construction": "Construção",
      "education": "Educação",
      "healthcare": "Saúde",
      "travel_and_hospitality": "Viagem e hospitalidade",
      "entertainment_news_media_music": "Entretenimento, notícias e mídia",
      "energy": "Energia",
      "manufacturing": "Manufatura",
      "fashion_and_clothing": "Moda e roupas",
      "mining": "Mineração",
      "consulting_services": "Consultoria/serviços",
      "other": "Outro"
    },
    "classes": {
      "accepted_users": "Usuários aceitos",
      "pending_users": "Usuários pendentes",
      "success_class_updated": "A sala foi atualizada com sucesso",
      "success_remove_user":"Remover usuário da classe com sucesso",
      "reports": "Relatórios",
      "filter_menu": {
        "all": "Todos",
        "active": "Ativo",
        "not_started": "Não iniciado",
        "draft": "Rascunhos",
        "finished": "Finalizados"
      },
      "table_titles": {
        "start_date": "Data de início",
        "end_date": "Data de término",
        "status": "Status"
      },
      "classes_details": {
        "left": "saiu",
        "to_go": "ir",
        "edit_class_name": "Editar {name}",
        "menu": {
          "overview": "Visão geral",
          "detailed_progress": "Progresso detalhado",
          "time_tracking": "Monitoramento de tempo"
        },
        "overview_section": {
          "title": "Visão geral",
          "students": "Estudantes",
          "view_list": "Ver lista",
          "goals": "Metas",
          "no_goals_set": "Nenhuma mete definida para esta sala.",
          "minutes_per_day": "Minutos por dia",
          "days_practice_per_week": "dias de prática por semana",
          "set_goals": "Definir metas",
          "assessment_test_results": "Resultado da avaliação de teste",
          "average_score": "Pontuação média",
          "test_before_class_stats": "Dias para fazer a avaliação de teste"
        },
        "students_section": {
          "title": "Estudantes",
          "pro_licence": "Licença Pro",
          "assessment_test": "Pontuação da avaliação",
          "date_take_assessment": "Data de avaliação",
          "last_active_practice": "Tempo da última prática",
          "practice_days_week": "Dias de prática na semana",
          "min_spent": "Min. praticados",
          "last_eps": "Último EPS",
          "avg_daily_use": "Uso médio diário (min)",
          "copy_paste_emails": "Copie e cole os endereços de e-mail",
          "module_name": "Nome do módulo",
          "lesson_name": "Nome da lição",
          "lesson_EPS": "Lição EPS",
          "lesson_take_date": "Data da lição",
          "difficulty_level": "Nível de dificuldade"
        },
        "activity_reports": {
          "title": "Relatórios de atividade",
          "lessons_overview": "Visão geral das lições",
          "number_of_lessons_practiced": "Número de lições e minutos de prática",
          "average_practice": "Tempo médio de prática por dia (minutos)",
          "progress": "Gráfico de progresso (EPS médio)",
          "0_5_percent": "0% - 5%",
          "6_10_percent": "6% - 10%",
          "11_50_percent": "11% - 50%",
          "51_70_percent": "51% - 70%",
          "mt_70_percent": "Mais de 70%"
        }
      },
      "create_class_flow": {
        "save_finish_later": "Salvar e finalizar mais tarde",
        "cancel": "Cancelar",
        "save": "Salvar",
        "next": "Próxima",
        "previous": "Anterior",
        "details": "Detalhes",
        "list_students_modal": {
          "got_it": "Entendi!",
          "warning_no_student": "Nenhum estudante foi convidado"
        },
        "class_details": {
          "start_end_date": "Data de início e término"
        },
        "add_students": {
          "copy_paste_emails": "Copie e cole os endereços de e-mail",
          "insert_multiple_emails": "Insira múltiplos e-mails (separados por vírgula)"
        },
        "class_overview": {
          "details": "Detalhes",
          "start_end_date": "Data de início e término",
          "not_selected": "Não selecionado",
          "create_and_send_invites": "Criar e enviar convites"
        },
        "class_created": {
          "goals_section": {
            "practice_at_least": "Pratique pelo menos",
            "days_week": "dias por semana.",
            "keep_them_engaged": "Mantenha-os engajados semanalmente",
            "practice": "Pratique",
            "minutes_day": "minutos por dia.",
            "studies_review": "Estudos mostram que praticar pelo menos 10 minutos por dia produz os melhores resultados ao aprender um novo idioma.",
            "take_assessment_test": "Fazer avaliação de teste",
            "days_before_invitations": "dias após o convite.",
            "next": "Próximo",
            "will_do_this_later": "Farei mais tarde."
          }
        }
      }
    },
    "dashboard": {
      "reports_overview": "Visão geral de relatórios",
      "notifications": "Notificações",
      "overview": "Visão geral",
      "manage": "Gerenciar",
      "licenses": "Licenças",
      "users": "Usuários",
      "request_license": "Solicitar licença",
      "student": {
        "view_class": "Ver sala",
        "view_all_classes": "Ver todas as salas",
        "goals": {
          "minutes_per_day": "Meta de { minutes } minutos por dia",
          "minutes_per_day_value": "Sua média é de { minutes } minutos por dia",
          "days_per_week": "Meta de {days} dias por semana",
          "days_per_week_value": "Sua média é de {days} dias de prática por semana",
          "level": "Nível {level}",
          "level_value": "Média de {level}%"
        },
        "minutes_spend_per_day": "Minutos é o tempo médio de prática por dia"
      }
    },
    "charts": {
      "active_users": "Usuários ativos",
      "avg_practice_time": "Tempo médio de prática",
      "avg_eps": "EPS",
      "number_of_lessons": "Número de lições",
      "number_of_seconds": "Tempo praticado",
      "user_eps_score": "EPS",
      "not_active": "Inativo",
      "1_4_days": "1-4 dias por semana",
      "5_5_days": "5 dias por semana",
      "6_7_days": "6-7 dias por semana",
      "percentage": "Porcentagem"
    }
  }
  